"use client";

import { Check } from "lucide-react";

interface Step {
  number: number;
  title: string;
  description?: string;
}

interface StepperProps {
  steps: Step[];
  currentStep: number;
}

export default function Stepper({ steps, currentStep }: StepperProps) {
  return (
    <div className="w-full mb-8">
      <div className="hidden lg:flex items-center justify-between relative">
        <div className="absolute top-5 left-0 right-0 h-0.5 bg-gray-200" />
        <div
          className="absolute top-5 left-0 h-0.5 bg-primary transition-all duration-500"
          style={{
            width: `${((currentStep - 1) / (steps.length - 1)) * 100}%`,
          }}
        />
        {steps.map((step) => (
          <div key={step.number} className="relative flex flex-col items-center z-10">
            <div
              className={`w-10 h-10 rounded-full flex items-center justify-center text-sm font-bold transition-all duration-300 ${
                step.number < currentStep
                  ? "bg-primary text-white"
                  : step.number === currentStep
                  ? "bg-primary text-white ring-4 ring-primary-light"
                  : "bg-gray-200 text-gray-500"
              }`}
            >
              {step.number < currentStep ? (
                <Check size={18} />
              ) : (
                step.number
              )}
            </div>
            <span
              className={`mt-2 text-xs text-center max-w-[80px] ${
                step.number <= currentStep
                  ? "text-primary font-semibold"
                  : "text-gray-400"
              }`}
            >
              {step.title}
            </span>
          </div>
        ))}
      </div>

      <div className="lg:hidden">
        <div className="flex items-center gap-3 bg-primary-light p-4 rounded-xl">
          <div className="w-10 h-10 bg-primary text-white rounded-full flex items-center justify-center font-bold">
            {currentStep}
          </div>
          <div>
            <p className="text-xs text-gray-500">
              Passo {currentStep} de {steps.length}
            </p>
            <p className="text-sm font-semibold text-primary">
              {steps.find((s) => s.number === currentStep)?.title}
            </p>
          </div>
        </div>
        <div className="flex gap-1 mt-3">
          {steps.map((step) => (
            <div
              key={step.number}
              className={`h-1.5 flex-1 rounded-full transition-all ${
                step.number <= currentStep ? "bg-primary" : "bg-gray-200"
              }`}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
